import { render, staticRenderFns } from "./Usuarios.vue?vue&type=template&id=23494b72&scoped=true"
import script from "./Usuarios.vue?vue&type=script&lang=js"
export * from "./Usuarios.vue?vue&type=script&lang=js"
import style0 from "../../../css/crud.css?vue&type=style&index=0&id=23494b72&prod&scoped=true&lang=css&external"
import style1 from "./Usuarios.vue?vue&type=style&index=1&id=23494b72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23494b72",
  null
  
)

export default component.exports